import { ActionReducerMap } from "@ngrx/store";
import { authenticationReducer } from "./Authentication/authentication.reducer";
import { LayoutState, layoutReducer } from "./layouts/layouts.reducer";
import { AuthenticationState } from "./Authentication/auth.models";
import { profileReducer } from "./Profile/profile.reducer";
import { roleRecordReducer, RoleRecordsState } from "./Roles/roles.reducer";
import { manualsRecordReducer, ManualsRecordsState } from "./Manuals/manuals.reducer";
import { changelogsRecordReducer, ChangelogsRecordsState } from "./Changelogs/changelogs.reducer";
import { faqsRecordReducer, FaqsRecordsState } from "./Faqs/faqs.reducer";
import { SupportRequestRecordsState, supportRequestsRecordReducer } from "./SupportRequests/support-requests.reducer";
import { changelogVersionsRecordReducer, ChangelogVersionsRecordsState } from "./ChangelogVersions/changelog-versions.reducer";
import { clubRecordReducer, ClubRecordsState } from "./Clubs/clubs.reducer";
import { TaskboardRecordsState, taskboardReducer } from "./Taskboard/taskboard.reducer";
import { DossierRecordReducer, DossierRecordsState } from "./Dossier/dossier.reducer";
import { dossierAttachmentRecordReducer, DossierAttachmentRecordsState } from "./DossierAttachment/dossier-attachment.reducer";
import { userRecordReducer, UserRecordsState } from "./Users/users.reducer";
import { SentCorrespondencesRecordReducer, SentCorrespondencesRecordsState } from "./SentCorrespondence/sent-correspondence.reducer";
import { MemberRecordReducer, MemberRecordsState } from "./Member/member.reducer";
import { memberAttachmentRecordReducer, MemberAttachmentRecordsState } from "./MemberAttachment/member-attachment.reducer";
import { DashboardRecordReducer, DashboardRecordsState } from "./Dashboard/dashboard.reducer";
import { MutationRecordReducer, MutationRecordsState } from "./Mutation/mutation.reducer";
import { ReportRecordReducer, ReportRecordsState } from "./Report/report.reducer";
import { PaymentsBatchRecordReducer, PaymentsBatchRecordsState } from "./PaymentsBatch/payments-batch.reducer";
import { PaymentsRecordReducer, PaymentsRecordsState } from "./Payments/payments.reducer";
import { DossierInvoicesRecordReducer, DossierInvoicesRecordsState } from "./DossierInvoice/dossier-invoice.reducer";
import { paymentGatewayRecordReducer, PaymentGatewayRecordsState } from "./PaymentGateway/payment-gateway.reducer";
import { PaymentArrangementRecordReducer, PaymentArrangementRecordsState } from "./PaymentArrangement/payment-arrangement.reducer";

export interface RootReducerState {
    layout: LayoutState;
    auth: AuthenticationState;
    profile: AuthenticationState;
    rolesList: RoleRecordsState;
    manualsRecords: ManualsRecordsState;
    changelogsRecords: ChangelogsRecordsState;
    faqsRecords: FaqsRecordsState;
    supportRequestRecords: SupportRequestRecordsState;
    changelogVersionsRecords: ChangelogVersionsRecordsState;
    clubRecords: ClubRecordsState,
    taskboardRecords: TaskboardRecordsState;
    dossierRecords: DossierRecordsState;
    dossierAttachmentRecords: DossierAttachmentRecordsState;
    userRecords: UserRecordsState;
    sentCorrespondencesRecords: SentCorrespondencesRecordsState;
    memberRecords: MemberRecordsState;
    memberAttachmentRecords: MemberAttachmentRecordsState;
    dashboardRecords: DashboardRecordsState;
    mutationRecords: MutationRecordsState;
    reportRecords: ReportRecordsState;
    paymentsBatchRecords: PaymentsBatchRecordsState;
    paymentsRecords: PaymentsRecordsState;
    dossierInvoicesRecords: DossierInvoicesRecordsState;
    paymentGatewayRecords: PaymentGatewayRecordsState;
    paymentArrangementRecords: PaymentArrangementRecordsState;

}

export const rootReducer: ActionReducerMap<RootReducerState> = {
    layout: layoutReducer,
    auth: authenticationReducer,
    profile: profileReducer,
    rolesList: roleRecordReducer,
    manualsRecords: manualsRecordReducer,
    changelogsRecords: changelogsRecordReducer,
    faqsRecords: faqsRecordReducer,
    supportRequestRecords: supportRequestsRecordReducer,
    changelogVersionsRecords: changelogVersionsRecordReducer,
    clubRecords: clubRecordReducer,
    taskboardRecords: taskboardReducer,
    dossierRecords: DossierRecordReducer,
    dossierAttachmentRecords: dossierAttachmentRecordReducer,
    userRecords: userRecordReducer,
    sentCorrespondencesRecords: SentCorrespondencesRecordReducer,
    memberRecords: MemberRecordReducer,
    memberAttachmentRecords: memberAttachmentRecordReducer,
    dashboardRecords: DashboardRecordReducer,
    mutationRecords: MutationRecordReducer,
    reportRecords: ReportRecordReducer,
    paymentsBatchRecords: PaymentsBatchRecordReducer,
    paymentsRecords: PaymentsRecordReducer,
    dossierInvoicesRecords: DossierInvoicesRecordReducer,
    paymentGatewayRecords: paymentGatewayRecordReducer,
    paymentArrangementRecords: PaymentArrangementRecordReducer
}